import addTrailingSlash from 'utils/addTrailingSlash'

export default ({ pathname }) => addTrailingSlash(pathname)
